import { useEffect } from 'react';
import { api } from '../api';

/**
 * Sets document.title to "<event name> — <suffix>" once the (public, unauthenticated) event data loads.
 *
 * `null` means the event is not known yet — a `/t/:token` page before its token resolves, or one
 * whose token resolves to nothing. `undefined` asks for the default event, so passing it there
 * titled an unknown ticket link "MOONFIELD FEST 2026 — …" (TICK-143); `null` titles it JamTick.
 */
export function usePageTitle(eventSlug: string | undefined | null, suffix: string) {
  useEffect(() => {
    if (eventSlug === null) {
      document.title = `JamTick — ${suffix}`;
      return;
    }
    let cancelled = false;
    api
      .getEvent(eventSlug)
      .then((event) => {
        if (!cancelled) document.title = `${event.name} — ${suffix}`;
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [eventSlug, suffix]);
}
